import { captureException } from '@sentry/react';
import { useState } from 'react';

export default function useLocalStorage<T>(key: string, initialValue: T): [T, (x: T) => void] {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      captureException(error);
      return initialValue;
    }
  });

  const setValue = (value: T): void => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      captureException(error);
    }
  };

  return [storedValue, setValue];
}
